<template>
  <v-dialog v-model="dialog" max-width="800" persistent>
    <v-card>
      <v-card-title
        class="headline py-3 px-2 px-md-5 d-flex align-center"
        style="font-size: 1.1rem"
      >
        <v-icon class="mr-2" color="primary" :size="$vuetify.breakpoint.smAndDown ? 24 : 32"
          >article</v-icon
        >
        <span class="">Detalhes da Solicitação</span>
        <v-spacer />
        <v-btn color="primary" icon @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider class="mx-2 mx-md-5 mb-3 mb-md-5" />
      <v-card-text class="d-flex flex-column justify-space-around px-2 px-md-5 py-2 py-md-4">
        <v-row class="mx-4" dense>
          <v-col cols="12" sm="6" class="mb-2">
            <div class="info-label">Nº Protocolo:</div>
            <div class="info-value">{{ resultado.id }}</div>
            <div class="info-label">Nome da Empresa:</div>
            <div class="info-value">{{ resultado.nomeEmpresa }}</div>
            <div class="info-label">CNPJ:</div>
            <div class="info-value">{{ resultado.cnpj | cnpj }}</div>
          </v-col>
          <v-col cols="12" sm="6" class="mb-2">
            <div class="info-label">Tipo de Solicitação:</div>
            <div class="info-value">{{ formatarTexto(resultado.tipoSolicitacao) }}</div>
            <div class="info-label">Data da Solicitação:</div>
            <div class="info-value">{{ formatData(resultado.dataCriacao) }}</div>
            <div class="info-label">Situação:</div>
            <div class="info-value">
              <span
                :class="{
                  // 'green--text font-weight-bold': resultado.status === 'AUTORIZADO',
                  // 'red--text font-weight-bold': resultado.status === 'DOCUMENTACAO_PENDENTE',
                  // 'orange--text font-weight-bold': resultado.status === 'EM_ANALISE_ASSESSORIA',
                }"
                >{{ formatSituacao(resultado.status) }}</span
              >
            </div>
          </v-col>
        </v-row>
        <template v-if="resultado.status === 'DOCUMENTACAO_PENDENTE'">
          <h3 class="mt-2 mb-2"><v-icon class="">document_scanner</v-icon> Documentos Pendentes</h3>
          <section v-for="doc in resultado.arquivos" :key="doc.id" dense>
            <v-list v-if="doc.aprovado == null" style="width: 100%" dense>
              <v-list-item :key="doc.id" class="card-docs">
                <v-list-item-content>
                  <v-list-item-subtitle class="d-flex flex-row align-center justify-space-between">
                    <section class="d-flex flex-row align-center">
                      <v-icon class="mr-3">picture_as_pdf</v-icon>
                      <p class="ma-0">Documento:<br />{{ formatarTexto(doc.tipoDocumento) }}</p>
                    </section>
                    <section class="d-flex flex-row align-center">
                      <v-chip color="blue lighten-4 pa-3" small>
                        <v-icon class="blue--text" size="22">hourglass_empty</v-icon>
                        <span class="blue--text ml-2">Aguardando Análise</span>
                      </v-chip>
                    </section>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list-item-content v-if="doc.aprovado == false" class="px-4 card-docs mb-5 py-5">
              <section class="d-flex flex-row justify-space-between align-center mb-3">
                <v-list-item-subtitle class="d-flex flex-row align-center justify-space-between"
                  >Documento: {{ formatarTexto(doc.tipoDocumento) }} <br />
                  <br />
                  Motivo da Rejeição: {{ doc.motivo?.descricao }}
                  <section class="d-flex flex-row align-center mb-2">
                    <v-chip class="orange lighten-4 pa-3" small>
                      <v-icon class="orange--text" size="22">warning</v-icon>
                      <span class="orange--text ml-2">Pendente</span>
                    </v-chip>
                  </section>
                </v-list-item-subtitle>
              </section>
              <UploadFile
                :descricao="doc.tipoDocumento"
                :regraNumber="null"
                :key="doc.tipoDocumento"
                :listaDocumentos="[doc]"
                :fileName="doc.nomeArquivo || 'Nenhum arquivo selecionado'"
                @recuperarFileName="nome => (doc.nomeArquivo = nome)"
                :isDocAprovado="doc.aprovado"
              />
              <v-btn
                :disabled="!checkDoc(doc.tipoDocumento)"
                class="elevation-0"
                color="primary"
                small
                @click="ajustarDocumento(doc)"
                >Enviar</v-btn
              >
            </v-list-item-content>
            <!-- <v-list v-if="doc.aprovado" style="width: 100%" dense>
                <v-list-item :key="doc.id" class="card-docs">
                  <v-list-item-content>
                    <v-list-item-subtitle
                      class="d-flex flex-row align-center justify-space-between"
                    >
                      Documento: {{ formatarTexto(doc.tipoDocumento) }}<br />
                      <section class="d-flex flex-row align-center">
                        <v-icon class="green--text" size="22">check_circle</v-icon>
                        <span class="green--text ml-2">Aprovado</span>
                      </section>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list> -->
          </section>
        </template>
        <template
          v-if="
            resultado.status === 'EM_ANALISE_ASSESSORIA' &&
            tipoSolicitacaoList.includes(resultado.tipoSolicitacao)
          "
        >
          <div class="ma-6"><strong>NUP:</strong> {{ resultado.nup }}</div>
          <!-- <div><strong>Situação SUITE:</strong> {{ resultado.statusSuite }}</div> -->
        </template>
        <template
          v-if="
            ['AUTORIZADO'].includes(resultado.status) &&
            !tipoSolicitacaoList.includes(resultado.tipoSolicitacao)
          "
        >
          <v-divider class="my-4" />
          <v-btn
            color="success"
            @click="baixarDocumentoAutorizacao(base64ToUint8Array(resultado.autorizacao))"
            >Baixar Documento de Autorização</v-btn
          >
        </template>
        <template
          v-if="
            tipoSolicitacaoList.includes(resultado.tipoSolicitacao) &&
            ['AUTORIZADO'].includes(resultado.status)
          "
        >
          <div class="ma-6 d-flex justify-center align-center">
            <a
              :href="`https://www.arce.ce.gov.br/download/resolucoes-arce`"
              target="_blank"
              class="text--center"
              style="font-size: 1rem"
            >
              <v-icon color="primary" size="20" right>open_in_new</v-icon>
              Clique aqui para acessar a área de resoluções da ARCE e fazer o download.
            </a>
          </div>
        </template>
        <v-divider class="my-4" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="closeDialog">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex';
import UploadFile from './UploadFile.vue';
import solicitacaoService from '@/services/spgc/solicitacao.service';
import dayjs from 'dayjs';
import documentos from '../enums/tipos-documentos';
import situacoesSolicitacao from '../enums/situacoes-solicitacao';

export default {
  name: 'DialogConsultarSolicitacao',
  components: {
    UploadFile,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    resultado: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tipoSolicitacaoList: ['COMERCIALIZADOR', 'AUTOIMPORTADOR', 'AUTOPRODUTOR'],
    };
  },
  computed: {
    ...mapState('spgc', [
      'formSolicitacao',
      'documentacaoPorTipoSolicitacao',
      'possuiSolicitacaoEmAndamento',
    ]),
  },
  methods: {
    formatarTexto(texto) {
      if (!texto) return '';
      // Substitui underscores por espaço, coloca só a primeira letra maiúscula de cada palavra
      return (
        documentos[texto]?.descricao ||
        texto
          .toLowerCase()
          .replace(/_/g, ' ')
          .replace(/\b\w/g, l => l.toUpperCase())
      );
    },
    formatSituacao(status) {
      return situacoesSolicitacao[status] || status;
    },
    closeDialog() {
      this.$emit('update:dialog', false);
    },
    ajustarDocumento(doc) {
      let file = this.formSolicitacao.arquivos.filter(
        doc => doc.tipoDocumento === doc.tipoDocumento
      );
      solicitacaoService
        .updateDocument(file[0].conteudoBase64, doc.id, this.resultado.id)
        .then(response => {
          this.$emit('update:solicitacao', true);
        })
        .catch(error => {
          console.error('Error updating document:', error);
        });
    },
    baixarDocumentoAutorizacao(bytes, nomeArquivo = 'documento.pdf', mimeType = 'application/pdf') {
      let blob;
      if (bytes instanceof Uint8Array || Array.isArray(bytes)) {
        blob = new Blob([new Uint8Array(bytes)], { type: mimeType });
      } else if (bytes instanceof ArrayBuffer) {
        blob = new Blob([bytes], { type: mimeType });
      } else {
        console.error('Formato de bytes não suportado');
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = nomeArquivo;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 100);
    },
    base64ToUint8Array(base64) {
      const binary = atob(base64);
      const len = binary.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return bytes;
    },
    checkDoc(tipoDocumento) {
      return this.formSolicitacao.arquivos.some(
        doc => doc.tipoDocumento === tipoDocumento && !doc.aprovado
      );
    },
    formatData(data) {
      if (!data) return '';
      return dayjs(data).format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>

<style>
.card-docs {
  border: 0.5px solid #e0e0e0;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 8px 6px;
}
.info-label {
  font-weight: bold;
  margin-top: 6px;
  font-size: 0.98rem;
}
.info-value {
  margin-bottom: 6px;
  font-size: 0.97rem;
  word-break: break-word;
}
@media (max-width: 600px) {
  .v-card__title {
    font-size: 1rem !important;
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .info-label,
  .info-value {
    font-size: 0.93rem !important;
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
  .card-docs {
    padding: 6px 2px !important;
    margin-bottom: 6px !important;
  }
}
</style>
